// extracted by mini-css-extract-plugin
module.exports = {"content":"AboutPage_content__9Xo3o","image":"AboutPage_image__r7CNw","images":"AboutPage_images__9wXmh"};